import HttpApi, { HttpApiRequestOptions, HttpApiResult } from './HttpApi';
import ConfigDTO from '../models/misc/ConfigDTO';

export class FileApiController {
    // get: File/GetVideoPath?fileName=${encodeURIComponent(fileName)}
    public RouteGetVideoPath = (fileName: string) => `File/GetVideoPath?fileName=${encodeURIComponent(fileName)}`;
    public getVideoPath(fileName: string, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteGetVideoPath(fileName);
        return HttpApi.RestRequest<any, void>(null, 'get', url, requestOptions);
    }
    // get: File/GetAudioPath?fileName=${encodeURIComponent(fileName)}
    public RouteGetAudioPath = (fileName: string) => `File/GetAudioPath?fileName=${encodeURIComponent(fileName)}`;
    public getAudioPath(fileName: string, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteGetAudioPath(fileName);
        return HttpApi.RestRequest<any, void>(null, 'get', url, requestOptions);
    }
    // get: File/GetContentSas
    public RouteGetContentUri = () => `File/GetContentSas`;
    public getContentUri(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<ConfigDTO>> {
        let url = this.RouteGetContentUri();
        return HttpApi.RestRequest<any, ConfigDTO>(null, 'get', url, requestOptions);
    }
}
var service = new FileApiController();
export default service;



// WEBPACK FOOTER //
// ./src/api/FileApiController.ts